
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/[slug]",
      function () {
        return require("private-next-pages/event/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event/[slug]"])
      });
    }
  